import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_PAYOUT_ACCOUNT } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getLocalizedErrorMessage } from "../../utils/messageHelper";
import i18n from "../../i18n";

// API: GET /api/v1/payment/settlements?provider_type=lab&status=&payment_method=&search=&date_from=&date_to=&page=&limit=
// Returns the provider's settlement/withdrawal history (filterable + paginated).
export const fetchProviderSettlementsReducer = createAsyncThunk(
  ACTION_PAYOUT_ACCOUNT.fetch_provider_settlements,
  async (
    {
      provider_type = "lab",
      order_type = "",
      status = "",
      payment_method = "",
      search = "",
      date_from = "",
      date_to = "",
      page = 1,
      limit = 10,
    } = {},
    { rejectWithValue },
  ) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const params = new URLSearchParams({ provider_type, page, limit });
      if (order_type) params.append("order_type", order_type);
      if (status) params.append("status", status);
      if (payment_method) params.append("payment_method", payment_method);
      if (search) params.append("search", search);
      if (date_from) params.append("date_from", date_from);
      if (date_to) params.append("date_to", date_to);

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getProviderSettlements}?${params.toString()}`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        // result shape: { data: [...], total, page, limit, total_pages }
        return response.data.data;
      }
      return rejectWithValue(getLocalizedErrorMessage({ response }, i18n));
    } catch (error) {
      console.error("Error fetching provider settlements:", error);
      return rejectWithValue(getLocalizedErrorMessage(error, i18n));
    }
  },
);
